import { render } from "./menu.vue?vue&type=template&id=77d1bf40"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/c7p4yP7J/0/platform/zhenwu/iot-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/layout/components/Sidebar/menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "77d1bf40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('77d1bf40', __exports__)) {
    console.log('reload')
    api.reload('77d1bf40', __exports__)
  }
  
  module.hot.accept("./menu.vue?vue&type=template&id=77d1bf40", () => {
    console.log('re-render')
    api.rerender('77d1bf40', render)
  })

}


export default __exports__